import Http from './http';
import store from 'store';

class RegCatsService {
    constructor() {
        this.regulatoryCategories = null;
    }

    resetCache(){
        if (!this.regulatoryCategories) return;
        store.set('regulatoryCategories', false)
        this.regulatoryCategories = null;
        this.getRegCats()
    }

    getRegCats(flat) {
        return new Promise((resolve, reject) => {
            if (store.get('regulatoryCategories', false)){
                this.regulatoryCategories = store.get('regulatoryCategories');
            }
            if (this.regulatoryCategories) resolve(this.regulatoryCategories);
            else {
                Http.get('/mapped-taxonomy/Regulatory Categories?flat=' + flat).then(resp => {
                    this.regulatoryCategories = resp.data;
                    store.set('regulatoryCategories', this.regulatoryCategories)
                    resolve(resp.data);
                });
            }
        })
    }
}

export default new RegCatsService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/regCats.js